import React, { useState } from "react";
import "./ECLSelect.css";
import { ECLFilterBar, ECLCheckBox, ECLThemeImage } from "../../index";
import useSelectorId from "../../../utilities/hooks/useSelectorId";
import ECLDropDown, {
   closeDropDown,
} from "../../Widgets/ECLDropDown/ECLDropDown";
import { translate } from "../../../utilities/Translate";
import debounce from "../../../utilities/debounce";

//The new portal implementation for dropdowns requires a little hacker-y to bubble events.
//Essentially anywhere you change state, add the custom event.  Is desynced from react state,
//so only rely on input events from a select element when using a debouncer function.
function customInputEvent(Element) {
   Element.dispatchEvent(new CustomEvent("input", { bubbles: true }));
}

export default function ECLSelect(props) {
   //PROPS
   // multiselect - if present, it's a multiselect
   // placeholder - if present, fills the "trigger" for the select menu
   // setOptions - function to set selected options state in parent
   // inModal - will be passed to ECLDropDown
   // options = [
   //    {
   //      id: Unique Value like a UUID (but doesn't necessarily have to be, could be a primary key of some other kind),
   //      searchableString: string value,
   //      jsx: JSX representation,
   //      selected: initial checked value
   //    },
   //    etc.
   //  ]
   //playwright - string - id to detect landmark dropdowns with playwright
   //customTrigger - arbitrary jsx you can use for the trigger
   // menuWidth - number/string ("unset") - make the select larger/smaller than the trigger
   //containerId - optionally include a containerID to tell the dropdown where to render your menu
   //startOpen - open select on start
   const [filterText, setFilterText] = useState("");
   const [placeholderFirstView, setPlaceholderFirstView] = useState(true);
   const checkid = useSelectorId();

   let selectionsToDisplay = "";

   if (
      (!props.placeholder && props.options) ||
      (!placeholderFirstView && props.options)
   ) {
      selectionsToDisplay = props.options
         .filter((optionObj) => optionObj.selected)
         .map((optionObj) => optionObj.searchableString)
         .join(", ");
   }

   //Error handling so broken select doesn't break page
   //might need to handle malformed options array here too
   if (!props.options || !props.setOptions) {
      console.error("props.options or props.setOptions not provided");
      return <div className="ecl-select">{translate("Select Menu Error")}</div>;
   }

   const updateSingleSelectOptions = (index) => {
      if (placeholderFirstView) {
         setPlaceholderFirstView(false);
      }
      const updatedSelectionsArray = [...props.options];
      updatedSelectionsArray.forEach((option, i) => {
         option.selected = index === i ? true : false;
      });
      props.setOptions(updatedSelectionsArray);
   };

   const updateMultiSelectOptions = (index) => {
      if (placeholderFirstView) {
         setPlaceholderFirstView(false);
      }
      const updatedSelectionsArray = [...props.options];
      updatedSelectionsArray[index].selected =
         !updatedSelectionsArray[index].selected;
      props.setOptions(updatedSelectionsArray);
   };

   if (props.options.length > 999) {
      return (
         <div className="ecl-select-new" id={`ecl-select-container-${checkid}`}>
            <ECLDropDown
               containerId={props.containerId}
               inModal={props.inModal}
               filterText={filterText}
               playwright={props.playwright}
               disableDefaultStyling={true}
               menuWidth={props.menuWidth}
               startOpen={props.startOpen}
               trigger={
                  props.customTrigger ? (
                     <div className="select-custom-trigger">
                        {props.customTrigger}
                     </div>
                  ) : (
                     <div className="select-menu-trigger global-menu-select">
                        {(props.placeholder && placeholderFirstView) ||
                        (props.placeholder && selectionsToDisplay === "") ? (
                           <span id="ecl-select-new-span">
                              {props.placeholder}
                           </span>
                        ) : (
                           <span
                              id="ecl-select-new-span"
                              title={selectionsToDisplay}
                           >
                              {selectionsToDisplay}
                           </span>
                        )}
                        <ECLThemeImage
                           fontAwesome="chevron-down"
                           alt={translate("chevron-down")}
                        />
                     </div>
                  )
               }
            >
               <ECLFilterBar
                  class="select-menu-filter"
                  defaultValue={filterText}
                  onInput={debounce((input) => {
                     setFilterText(input);
                     props.setOptions(
                        props.options.map((option) => {
                           return {
                              ...option,
                              selected: option.searchableString
                                 .toLocaleLowerCase()
                                 .includes(input.toLocaleLowerCase()),
                           };
                        }),
                     );
                     customInputEvent(
                        document.querySelector(
                           `#ecl-select-container-${checkid}`,
                        ),
                     );
                  })}
               />
            </ECLDropDown>
         </div>
      );
   }

   return (
      //this wrapper is mostly here to allow class-targeted CSS
      <div className="ecl-select-new" id={`ecl-select-container-${checkid}`}>
         <ECLDropDown
            containerId={props.containerId}
            inModal={props.inModal}
            filterText={filterText}
            playwright={props.playwright}
            disableDefaultStyling={true}
            menuWidth={props.menuWidth}
            startOpen={props.startOpen}
            trigger={
               props.customTrigger ? (
                  <div className="select-custom-trigger">
                     {props.customTrigger}
                  </div>
               ) : (
                  <div className="select-menu-trigger global-menu-select">
                     {(props.placeholder && placeholderFirstView) ||
                     (props.placeholder && selectionsToDisplay === "") ? (
                        <span id="ecl-select-new-span">
                           {props.placeholder}
                        </span>
                     ) : (
                        <span
                           id="ecl-select-new-span"
                           title={selectionsToDisplay}
                        >
                           {selectionsToDisplay}
                        </span>
                     )}
                     <ECLThemeImage
                        fontAwesome="chevron-down"
                        alt={translate("chevron-down")}
                     />
                  </div>
               )
            }
         >
            <>
               {props.filter && (
                  <ECLFilterBar
                     onInput={(input) => {
                        setFilterText(input);
                     }}
                     class="select-menu-filter"
                  />
               )}
               {props.multiselect ? (
                  <div
                     className="multiselect-list-container"
                     style={{
                        maxWidth: props.menuWidth && props.menuWidth + "px",
                     }}
                  >
                     <div className="multiselect-control-container">
                        <button
                           onClick={(e) => {
                              e.preventDefault();
                              props.setOptions(
                                 props.options.map((o) => {
                                    const box = document.getElementById(
                                       checkid + "-" + CSS.escape(o.id),
                                    );
                                    if (box) box.checked = true;
                                    return { ...o, selected: true };
                                 }),
                              );
                              customInputEvent(
                                 document.querySelector(
                                    `#ecl-select-container-${checkid}`,
                                 ),
                              );
                           }}
                        >
                           {translate("Select All")}
                        </button>
                        <button
                           onClick={(e) => {
                              e.preventDefault();
                              props.clearFilterFunction &&
                                 props.clearFilterFunction();
                              props.setOptions(
                                 props.options.map((o) => {
                                    const box = document.getElementById(
                                       checkid + "-" + CSS.escape(o.id),
                                    );
                                    if (box) box.checked = false;
                                    customInputEvent(
                                       document.querySelector(
                                          `#ecl-select-container-${CSS.escape(checkid)}`,
                                       ),
                                    );
                                    return { ...o, selected: false };
                                 }),
                              );
                           }}
                        >
                           {translate("Clear")}
                        </button>
                        <p data-testid={props.playwright + "-paragraph"}>
                           {props.options.filter((o) => o.selected).length}{" "}
                           {translate("selected")}
                        </p>
                     </div>

                     {props.options.map((optionObj, index) => {
                        if (
                           optionObj.searchableString
                              .toLocaleLowerCase()
                              .includes(filterText.toLocaleLowerCase())
                        ) {
                           return (
                              <ECLCheckBox
                                 key={`${checkid}-${CSS.escape(optionObj.id)}`}
                                 defaultChecked={optionObj.selected}
                                 id={`${checkid}-${CSS.escape(optionObj.id)}`}
                                 name={
                                    optionObj.jsx
                                       ? optionObj.jsx
                                       : String(optionObj.searchableString)
                                 }
                                 onClick={() => {
                                    updateMultiSelectOptions(index);
                                    customInputEvent(
                                       document.querySelector(
                                          `#ecl-select-container-${checkid}`,
                                       ),
                                    );
                                 }}
                              />
                           );
                        }
                     })}
                  </div>
               ) : (
                  <div
                     className="singleselect-list-container"
                     style={{
                        maxWidth: props.menuWidth && props.menuWidth + "px",
                     }}
                  >
                     {props.options.map((optionObj, index) => {
                        if (
                           optionObj.searchableString
                              .toLocaleLowerCase()
                              .includes(filterText.toLocaleLowerCase())
                        ) {
                           return (
                              <button
                                 key={CSS.escape(optionObj.id)}
                                 className="select-option"
                                 onClick={(e) => {
                                    e.preventDefault();
                                    updateSingleSelectOptions(index);
                                    customInputEvent(
                                       document.querySelector(
                                          `#ecl-select-container-${checkid}`,
                                       ),
                                    );
                                    closeDropDown();
                                 }}
                              >
                                 {optionObj.jsx}
                              </button>
                           );
                        }
                     })}
                  </div>
               )}
            </>
         </ECLDropDown>
      </div>
   );
}
